import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { Tooltip } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
// import  libraryIcon  from '../../../assets/Logos/Asset_Library.png'
import { HomeIcon, ModelUploader, WorkInstructions, ManageUsers, ManageDevices, Feedback, FAQ, InstructionViewer, libraryIcon } from '../../Templates/icons'

import { online } from "../../../util/user_util"

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: "1em",
    },
}))(Tooltip);

const renderIcon = (portalName) => {
    switch (portalName) {
        case ("Home"):
           return HomeIcon
       case ("Model Uploader"):
           return ModelUploader
       case ("Work Instructions"): 
           return WorkInstructions
       case ("Manage Users"): 
           return ManageUsers
       case ("Manage Devices"): 
           return ManageDevices
       case ("Feedback"):
           return Feedback
       case ("FAQ"):
           return FAQ
       case ("Instruction Viewer"):
           return InstructionViewer 
       case ("Attachment Library"):
           return libraryIcon
       default :
           return <p>?</p>
    }
   }

const PortalLink = ({ portalName="", url}) => {
    //!navigator.onLine

    // State to track if the Feedback link should be disabled due to being offline
    const [isOfflineForFeedback, setIsOfflineForFeedback] = useState(false);

    useEffect(() => {
        // Only run the check for the Feedback link
        if (portalName === "Feedback") {
            let isMounted = true;
            let intervalId = null; // To store the interval ID for cleanup

            // Define the check function to avoid repetition and use in listeners
            const performOnlineCheck = () => {
                // No check needed if component isn't mounted
                if (!isMounted) return;

                online().then(isOnline => {
                    if (isMounted) {
                        setIsOfflineForFeedback(!isOnline);
                    }
                }).catch(err => {
                    console.error("Error during periodic online check:", err);
                    if (isMounted) {
                        setIsOfflineForFeedback(true); // Assume offline on error
                    }
                });
            };

            // Initial check on mount
            performOnlineCheck();

            // Set up periodic polling
            // Check every 10 seconds (10000 milliseconds)
            intervalId = setInterval(performOnlineCheck, 10000);

            // Cleanup function to prevent state updates and remove listeners
            return () => {
                isMounted = false;
                // Clear the interval when the component unmounts
                if (intervalId) {
                    clearInterval(intervalId);
                }
            };
        }
    }, [portalName]); // Dependency array ensures this runs only if portalName changes

    // Render logic based on the state
    if (portalName === "Feedback" && isOfflineForFeedback) {
        // Render the disabled div if offline

        return <div id="portal-link" className="flex-column-centered" to={`/dashboard/${url}`} title="Feature not available offline" disabled draggable={false}
                    activeStyle={{ backgroundColor: "#f1f3f9", borderBottom: ".09375em solid #042763" }}>
                    {renderIcon(portalName)}  {/*<p className="portal-name">{portalName}</p> */}
                </div>   
    }else{
     return <NavLink id="portal-link" className="flex-column-centered" to={`/dashboard/${url}`} draggable={false}
                activeStyle={{ backgroundColor: "#f1f3f9", borderBottom: ".09375em solid #042763" }}>
                {renderIcon(portalName)} {/* <p className="portal-name">{portalName}</p> */}
            </NavLink>        
    }

}

export default PortalLink